import type { components } from '../../api/generated/schema';
import type { Comment, NewComment } from '../../domain/comments';
import { toPersonRef } from '../mapping';

type S = components['schemas'];

export function toComment(c: S['Comment']): Comment {
  return {
    id: c.id,
    author: c.author ? toPersonRef(c.author) : null,
    body: c.body,
    createdAt: c.created_at,
    isCollapsed: c.is_collapsed,
    replies: c.replies.map(toComment),
  };
}

export function toNewComment(comment: NewComment): S['CommentCreateRequest'] {
  return { body: comment.body, reply_to: comment.replyTo };
}
